// 商品属性
const attr_list = {
    heard_title: "商品属性",
    heard_btn: "新增",
    table_title: "数据列表",
    table_label1: "属性名称",
    table_label2: "商品类型",
    table_label3: "可选值列表",
    table_label4: "排序",
    table_btn1: "编辑",
    table_btn2: "删除",
    dialog_title1: "新增商品属性",
    dialog_title2: "编辑商品属性",
    dialog_label1: "商品类型:",
    dialog_label2: "属性名称:",
    dialog_label3: "排序:",
    dialog_label4: "可选值:",
    dialog_label5: "手动添加:",
    dialog_ph1: "请选择",
    dialog_tag: "请输入",
    dialog_radio1: "是",
    dialog_radio2: "否",
    rule_msg1: "请选择商品类型",
    rule_msg2: "请输入属性名称"
};

export default attr_list;
